export enum Paths {
  AUDIT = "/audit",
  DESIGN_SYSTEM = "/design-system",
}

export enum AuditPaths {
  ROOT = Paths.AUDIT,
  CHECK1003 = `${Paths.AUDIT}/1003-check/`,
  DATA_CONSISTENCY = `${Paths.AUDIT}/data-consistency/`,
  DOCUMENT_HEALTH = `${Paths.AUDIT}/document-health/`,
  CREDIT_LIABILITIES = `${Paths.AUDIT}/credit-liabilities/`,
  PROPERTIES_CHECK = `${Paths.AUDIT}/properties-check/`,
  APPRAISAL = `${Paths.AUDIT}/appraisal/`,
  BANK_STATEMENTS = `${Paths.AUDIT}/bank-statements/`,
  EMBED = `${Paths.AUDIT}/embed/`,
}

export const getNormalizedPath = (path: string): string => {
  if (path.length > 1 && path.endsWith("/")) {
    return path.slice(0, -1);
  }

  return path;
};
